<template>
    <svg viewBox="0 0 32 32" width="32" height="32">
        <rect class="svg-background" width="32" height="32" x="0" y="0" rx="4" fill="var(--logo-bg)" />
        <g id="TA Monogram">
            <line x1="0" x2="24" y1="0" y2="0" stroke="rgb(201,161,48)" stroke-width="2"
                transform="matrix(0,1,-1,0,16,4)" />
            <line x1="8" x2="24" y1="4" y2="4" stroke="rgb(201,161,48)" stroke-width="2" />
            <line x1="0" x2="5" y1="0" y2="0" stroke="rgb(201,161,48)" stroke-width="2"
                transform="matrix(0,1,-1,0,8,4)" />
            <line x1="0" x2="5" y1="0" y2="0" stroke="rgb(201,161,48)" stroke-width="2"
                transform="matrix(0,1,-1,0,24,4)" />
            <line x1="0" x2="25.632" y1="0" y2="0" stroke="rgb(27,140,94)" stroke-width="2"
                transform="matrix(0.351124,0.936329,-0.936329,0.351124,21,4)" />
            <line x1="0" x2="25.632" y1="0" y2="0" stroke="rgb(27,140,94)" stroke-width="2"
                transform="matrix(-0.351123,0.936329,-0.936329,-0.351123,21,4)" />
            <line x1="12" x2="28" y1="18" y2="18" stroke="rgb(27,140,94)" stroke-width="1.5" />
            <circle cx="16" cy="4" r="1.2" fill="rgb(201,161,48)" />
            <ellipse rx="1.2" ry="1.2" cx="21" cy="4" fill="rgb(27,140,94)" />
        </g>
    </svg>
</template>

